module.exports = __webpack_public_path__ + "static/media/logo-microsoft-azure.4eac1234.png";